import { createContext } from "react";

const errorContext = createContext();

export default errorContext;
